export default __webpack_public_path__ + "static/media/metalsmith.41da728e.JPG";